<template>
  <section class="add-trial-form">
    <Breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-trial-form
        v-model="model"
        @submit="addTrial"
        @getUsers="getUsers"
        :surgeonsPage="surgeonsPage"
        :questionnaires="questionnaires"
      />

      <rp-overlay :active="showOverlay">
        <rp-alert
          icon="done"
          message="The new study has been created successfully!"
          :onClick="closeOverlay" />
      </rp-overlay> 
    </div>

  </section>
</template>

<script>
import TrialForm from "raypro_ui/src/components/ui/forms/Trial"
import Breadcrumbs from "@/components/Breadcrumbs"
import Overlay from "raypro_ui/src/components/ui/Overlay"
import Alert from "raypro_ui/src/components/ui/Alert"
import page from "@/mixins/page"
import {getUsersByRoleAdmin} from 'raypro_ui/src/api/users'
import {createTrial} from 'raypro_ui/src/api/trials'
import {getQuestionnaires} from 'raypro_ui/src/api/questionnaire'

export default {
  mixins: [page],

  components: {
    "rp-trial-form": TrialForm,
    "rp-overlay": Overlay,
    "rp-alert": Alert,
    Breadcrumbs
  },

  data() {
    return {
      model: {questionnaire_ids: []},
      title: "New Study",
      breadcrumbs: [{ label: "New Study" }],
      surgeonsPage: {data: [], page: {page_size: 10, page_number: 1}},
      questionnaires: [],
      showOverlay: false,
    };
  },

  async mounted() {
    await this.getUsers(this.surgeonsPage.page)
    await this.getQuestionnaires()
  },

  methods: {
    async addTrial(trial) {
      let {data} = await createTrial({trial: trial})
      this.showOverlay = true
    },

    async getUsers(pageData) {
      let {data, page} = await getUsersByRoleAdmin(pageData, "surgeon")
      this.surgeonsPage = {
        page,
        data: data.map((x) => {
          return {
            id: x.id,
            name: `${x.profile.first_name} ${x.profile.last_name}`,
            email: x.email
          }
        })
      }
    },

    async getQuestionnaires() {
      let {data} = await getQuestionnaires()
      this.questionnaires = data
    },

    closeOverlay() {
      this.showOverlay = false
      this.$router.push({name: "all-studies"})
    },
  }
};
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/pages/Clinical/AddTrial.vue